var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-drag-move',{attrs:{"id":_vm.id}},[_c('div',{staticClass:"s-card-widget",style:({ left: _vm.left + 'px', top: _vm.top + 'px', width: _vm.width + 'px', height: _vm.height + 'px' })})])}
var staticRenderFns = []

export { render, staticRenderFns }